import { Box } from "@chakra-ui/react";
import React from "react";

export const MaxLengthCounter = ({
  maxLength,
  length,
  suffix = "文字",
}: {
  maxLength: number;
  length: number;
  suffix?: string;
}) => {
  return (
    <Box color={length > maxLength ? "caution" : "gray.700"} flexShrink={0} sx={{ fontVariantNumeric: "tabular-nums" }}>
      <Box as="span" fontWeight="bold" color={length > maxLength ? "caution" : "textBase"}>
        {length}
      </Box>
      {" / "}
      {maxLength}{suffix}
    </Box>
  );
};
